import { render, staticRenderFns } from "./batchKpiModal.vue?vue&type=template&id=12130ebf&scoped=true"
import script from "./batchKpiModal.vue?vue&type=script&lang=js"
export * from "./batchKpiModal.vue?vue&type=script&lang=js"
import style0 from "./batchKpiModal.vue?vue&type=style&index=0&id=12130ebf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12130ebf",
  null
  
)

export default component.exports